export type Range<T> = { low: number | null; high: number | null; value: T }

export const getFromRange = (ranges: Range<any>[], checkValue: number): any => {
  return (
    ranges.filter((r) => {
      return (r.high == null || r.high >= checkValue) && (r.low == null || r.low <= checkValue)
    })[0]?.value ?? null
  )
}
